/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown> }} Matching_Score_BadgeInputs */

const en_matching_score_badge = /** @type {(inputs: Matching_Score_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Matching Score: ${i?.score}%`)
};

const de_matching_score_badge = /** @type {(inputs: Matching_Score_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Matching-Score: ${i?.score}%`)
};

/**
* | output |
* | --- |
* | "Matching Score: {score}%" |
*
* @param {Matching_Score_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_badge = /** @type {((inputs: Matching_Score_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_badge(inputs)
	return en_matching_score_badge(inputs)
});